import { MODULE_CATALOGUE } from './modules';
import { COUNTRY_BASICS } from './countries';
export const ADD_ONS = {
    nphies: {
        code: 'nphies',
        attachesTo: ['opd', 'ipd', 'lab', 'pharmacy'],
        requires: ['core', 'insurance'],
        countries: ['SA'],
        settingsTab: 'integrations',
    },
    wasfaty: {
        code: 'wasfaty',
        attachesTo: ['pharmacy'],
        requires: ['core', 'pharmacy'],
        countries: ['SA'],
        settingsTab: 'integrations',
    },
};
export function addOnsAttachedTo(module) {
    return Object.values(ADD_ONS).filter((addOn) => addOn.attachesTo.includes(module));
}
export function addOnCountryProblem(code, branchCountries) {
    const addOn = ADD_ONS[code];
    if (!addOn || addOn.countries.length === 0)
        return null;
    const held = new Set([...branchCountries].filter((country) => Boolean(country)).map((country) => country.toUpperCase()));
    if (addOn.countries.some((country) => held.has(country)))
        return null;
    const label = MODULE_CATALOGUE.find((module) => module.code === code)?.name ?? code;
    const where = addOn.countries.map((country) => COUNTRY_BASICS[country]?.name ?? country).join(' or ');
    return `${label} is only available to a facility with a branch in ${where}`;
}
//# sourceMappingURL=add-ons.js.map